import { Box, Button, Paper, Typography, useTheme, CardContent, Divider, Stack } from "@mui/material";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { tokens } from "../../theme";
import TextField from '@mui/material/TextField';

import styles from './print-promi.module.css'

import { useState, useEffect, useMemo, useRef, useCallback } from "react";
import { useSelector } from "react-redux";
// import {  useDispatch } from "react-redux";
import { selectProducts, getKitsBySeller } from "../../store/products/products.selector";

import CircularProgress from '@mui/material/CircularProgress';
import { findProdByIdHasBefore, findProductsHandlerdById } from '../../utils/products-handler'

import TableFormKit from './table-form-kit'

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// import ptBR from "dayjs/locale/pt-br";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from 'dayjs';
import FormKitPageSkeleton from "./form-fit-skeleton";

import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

import ReactDOMServer from 'react-dom/server';

import TableComponent from "./form-fit-swal-table";

import Tooltip from '@mui/material/Tooltip';

import { timeOutBipInput } from "../../utils/form-utils";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSortUp, faSortDown } from '@fortawesome/free-solid-svg-icons';
import { faSortAlphaDown, faSortAlphaUpAlt } from '@fortawesome/free-solid-svg-icons';

import toast from "react-hot-toast";

import SemProduto from "../../assets/img/produto-sem-imagem.jpg"


import { generateImagesPDF } from "./utils";
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { formatToBRL } from "../../utils/formats";
import { FixedSizeList } from "react-window";


import { PieChart, Pie, Cell, Tooltip as RechartsTooltip, ResponsiveContainer, Legend } from "recharts";



const FormKitPage = ({ isLoading, setValuesToSave, valuesToSave, setInitialDate, initialDate, formType, dataToEdit, handleChangeActive, isActiveKit, setIsActiveKit, sellersKits, setUpdatedKit, setValueForResume, setValueForComission, setValueForComissionVeludos, setValueForComissionSacolas, failureToPay, setFailureToPay, handleChangeFailure, caseType, setCaseType, setIsDirty }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const MySwal = withReactContent(Swal);

    const [value, setValue] = useState('');

    const [devIdValue, setDevIdValue] = useState('');
    const [orderByNumber, setOrderByNumber] = useState(false);
    const [lastKitNumber, setLastKitNumber] = useState(0);

    const [imgToPrintArr, setImgToPrintArr] = useState([]);
    const [loadingBtnImg, setLoadingBtnImg] = useState(false);

    const [totalProdsOnKitByColor, setTotalProdsOnKitByColor] = useState([]);


    const lastIndexRef = useRef(-1);
    const normalizeId = (value) => String(value).padStart(6, "0");


    const [openedImageIndex, setOpenedImageIndex] = useState(null);
    const notes = dataToEdit?.generated_bill_notes || [];



    const sortedNotes = [...notes].sort(
        (a, b) => new Date(b.ts) - new Date(a.ts)
    );


    useEffect(() => {
        if (openedImageIndex === null) return;

        const handleKeyDown = (event) => {
            if (event.key === "Escape") {
                setOpenedImageIndex(null);
            }
        };

        window.addEventListener("keydown", handleKeyDown);
        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [openedImageIndex]);



    const handleChangeCaseType = (e) => {
        setIsDirty(true)
        setCaseType(e.target.value)
    }


    // console.log('values to Save here: ', valuesToSave)

    useEffect(() => {
        if (formType !== 'Criando') {
            if (valuesToSave?.length > 0) {
                const onlyImg = valuesToSave.map((data) => {
                    return (
                        {
                            id: data.id_produto,
                            imageUrl: data.imageUrl
                        }
                    )
                })
                setImgToPrintArr(onlyImg)
            }
        }
    }, [valuesToSave]);

    useEffect(() => {
        if (formType !== 'Criando') {
            if (valuesToSave?.length > 0) {
                const onlyImg = valuesToSave.map((data) => {
                    return (
                        {
                            id: data.id_produto,
                            imageUrl: data.imageUrl
                        }
                    )
                })
                setImgToPrintArr(onlyImg)
            }
        }
    }, []);



    useEffect(() => {
        if (formType === 'Criando') {
            if (sellersKits?.kits?.length > 0) {
                const getNextKitNumber = sellersKits.kits.map((data) => data.kit_number)
                const getBiggestOne = Math.max(...getNextKitNumber)
                const lastNumber = getBiggestOne + 1
                setLastKitNumber(lastNumber)
            } else {
                setLastKitNumber(1)
            }
        }
    }, []);


    useEffect(() => {
        if (dataToEdit?.kit_number) {
            const { kit_products, kit_case_model, ...kitWithoutProducts } = dataToEdit
            if (kit_case_model) {
                setCaseType(kit_case_model)
            } else {
                setCaseType('')
            }
            console.log('dataToEdit', dataToEdit)
            setUpdatedKit(kitWithoutProducts)

            const initValue = dayjs(kitWithoutProducts.pay_date, 'YYYY-MM-DD').startOf('day');
            setInitialDate(initValue)
            setIsActiveKit(!kitWithoutProducts.is_active)
            setFailureToPay(kitWithoutProducts.failure_to_pay)

            const objsToAdd = kit_products.flatMap((prods) => {
                const qty = Number(prods.quantity || 0);
                const qtyReturned = Number(prods.quantity_returned || 0);

                // ✅ base mais forte (inclui object_id)
                const base = `${prods.pk_kit_product}-${prods.object_id}-${prods.product_id}-${prods.content_type_id ?? ""}`;

                // Track remaining sold quantities for the current product ID
                let remainingSold = Number(prods.quantity_sold || 0);

                const returnedItems = Array.from({ length: qtyReturned }, (_, i) => ({
                    sell_price: prods.sell_price,
                    tamanho: prods?.tamanho,
                    model: prods.content_type,
                    id_produto: prods.product_id,
                    color__color: prods.color,
                    devolvido: true,
                    created_at: prods?.created_at,
                    modificado: prods?.modificado,
                    pk: prods?.pk_kit_product,
                    sold_prod_db: false,
                    object_id: prods?.object_id,
                    content_type_id: prods?.content_type_id,
                    imageUrl: prods?.imageUrl,
                    unit_id: `${base}-ret-${i}`, // ✅ único por unidade
                }));

                const nonReturnedItems = Array.from(
                    { length: Math.max(0, qty - qtyReturned) },
                    (_, i) => {
                        const isSold = remainingSold > 0;
                        if (isSold) remainingSold--;

                        return {
                            sell_price: prods.sell_price,
                            model: prods.content_type,
                            tamanho: prods?.tamanho,
                            id_produto: prods.product_id,
                            color__color: prods.color,
                            devolvido: false,
                            created_at: prods?.created_at,
                            modificado: prods?.modificado,
                            pk: prods?.pk_kit_product,
                            sold_prod_db: isSold,
                            object_id: prods?.object_id,
                            content_type_id: prods?.content_type_id,
                            imageUrl: prods?.imageUrl,
                            unit_id: `${base}-nr-${i}`, // ✅ único por unidade
                        };
                    }
                );

                return [...returnedItems, ...nonReturnedItems];

            });
            // console.log("objsToAdd: ", objsToAdd.sort((a, b) => {
            //     // First, sort by devolvido (false comes before true)
            //     if (a.devolvido !== b.devolvido) {
            //         return a.devolvido ? 1 : -1; // true (1) comes after false (-1)
            //     }
            //     // If devolvido is the same, sort by id_produto
            //     return a.id_produto - b.id_produto;
            // }));
            setValuesToSave((prev) => {
                if (JSON.stringify(prev) !== JSON.stringify(objsToAdd)) {
                    return [...objsToAdd]; // Replace or append based on your logic
                }
                return prev;
            })
        } else {
            console.log('criando um novo')
            setCaseType('')
        }
    }, [dataToEdit, setValuesToSave]);


    useEffect(() => {
        if (!dataToEdit?.kit_number) {
            const initialDate = new Date()
            const initValue = dayjs(initialDate).add(30, 'day')
            setInitialDate(initValue)
        }
    }, []);


    const productsData = useSelector(selectProducts)

    const [totalProds, setTotalProds] = useState(0);
    const [totalProdsValue, setTotalProdsValue] = useState(0);
    const [avgTicketKit, setAvgTicketKit] = useState(0);

    const [totalProdsReturned, setTotalProdsReturned] = useState(0);
    const [totalProdsValueReturned, setTotalProdsValueReturned] = useState(0);

    const [totalProdsSold, setTotalProdsSold] = useState(0);
    const [totalProdsValueSold, setTotalProdsValueSold] = useState(0);

    const [totalProdsOnKitByModel, setTotalProdsOnKit] = useState([]);

    const formatNumber = (data) => {
        return data.toLocaleString(
            "pt-br",
            {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }
        )
    }

    const formatPercentBR = (value) => {
        return Number(value || 0).toLocaleString("pt-BR", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
    };

    const PIE_COLORS = [

        "#ffc658",
        "#ff7f50",
        "#00c49f",
        "#a28bff",
        "#ff6699",
        "#66d9ff",
        "#9ccc65",
    ];



    useEffect(() => {
        if (valuesToSave?.length > 0) {
            const totalProds = valuesToSave?.length;
            const totalValue = valuesToSave?.reduce((acc, curr) => {
                return acc + Number(curr?.sell_price || 0);
            }, 0);

            const avgTicket = totalProds > 0 ? totalValue / totalProds : 0;

            setTotalProds(totalProds);
            setTotalProdsValue(totalValue);
            setAvgTicketKit(avgTicket);
            const newTotalByModel = valuesToSave.reduce((acc, curr) => {
                // Check if the model already exists in the accumulator
                const existingModel = acc.find(item => item.model === curr.model);

                if (existingModel) {
                    // Update the existing model's totals
                    existingModel.quantity += 1;
                    existingModel.sell_price += curr.sell_price;
                } else {
                    // Add a new entry for the model
                    acc.push({ ...curr, quantity: 1 });
                }

                return acc;
            }, []);
            setTotalProdsOnKit(newTotalByModel)

            const newTotalByColor = valuesToSave.reduce((acc, curr) => {
                const colorName = curr?.color__color || "Sem cor";
                const existingColor = acc.find((item) => item.name === colorName);

                if (existingColor) {
                    existingColor.quantity += 1;
                    existingColor.value += Number(curr.sell_price || 0);
                } else {
                    acc.push({
                        name: colorName,
                        quantity: 1,
                        value: Number(curr.sell_price || 0),
                    });
                }

                return acc;
            }, []);

            const colorDataWithPercent = newTotalByColor.map((item) => ({
                ...item,
                percent: totalProds > 0 ? Number(((item.quantity / totalProds) * 100).toFixed(2)) : 0,
            }));

            setTotalProdsOnKitByColor(colorDataWithPercent);


            if (formType === 'Editando') {
                const totalProdsReturneds = valuesToSave.filter((data) => !data.devolvido === false)?.length
                setTotalProdsReturned(totalProdsReturneds)
                const totalValueReturned = valuesToSave?.filter((data) => !data.devolvido === false)?.reduce((acc, curr) => acc += curr.sell_price, 0)
                setTotalProdsValueReturned(totalValueReturned)

                const totalProdsSold = valuesToSave.filter((data) => !data.devolvido === true)?.length
                setTotalProdsSold(totalProdsSold)
                const totalProdsValueSold = valuesToSave?.filter((data) => !data.devolvido === true)?.reduce((acc, curr) => acc += curr.sell_price, 0)
                setTotalProdsValueSold(totalProdsValueSold)



                if (dataToEdit?.is_active) {
                    console.log('logica para se estiver ativo, nova formula somente para os vendidos')

                    const totalProdsValueSoldOpenKit = valuesToSave?.filter((data) => (!data.sold_prod_db === false || !data.sold_prod === false) && data.model !== "embalagem")?.reduce((acc, curr) => acc += curr.sell_price, 0)
                    setValueForResume(totalProdsValueSoldOpenKit)

                    const totalProdsValueSoldNoPackageOpenKit = valuesToSave?.filter((data) => (!data.sold_prod_db === false || !data.sold_prod === false) && data.model !== "embalagem")?.reduce((acc, curr) => acc += curr.sell_price, 0)
                    setValueForComission(totalProdsValueSoldNoPackageOpenKit)

                    const totalProdsValueSoldNoPackageOpenKitVeludo = valuesToSave?.filter((data) => (!data.sold_prod_db === false || !data.sold_prod === false) && Number(data.id_produto) === 200000)?.reduce((acc, curr) => acc += curr.sell_price, 0)
                    setValueForComissionVeludos(totalProdsValueSoldNoPackageOpenKitVeludo)

                    const totalProdsValueSoldNoPackageOpenKitSacola = valuesToSave?.filter((data) => (!data.sold_prod_db === false || !data.sold_prod === false) && Number(data.id_produto) === 200001)?.reduce((acc, curr) => acc += curr.sell_price, 0)
                    setValueForComissionSacolas(totalProdsValueSoldNoPackageOpenKitSacola)
                } else {

                    console.log('fazer ao contrato para encerrado, como era feito antes')

                    const totalProdsValueSoldResume = valuesToSave?.filter((data) => !data.devolvido === true && data.model !== "embalagem")?.reduce((acc, curr) => acc += curr.sell_price, 0)
                    setValueForResume(totalProdsValueSoldResume)

                    const totalProdsValueSoldNoPackage = valuesToSave?.filter((data) => !data.devolvido === true && data.model !== "embalagem")?.reduce((acc, curr) => acc += curr.sell_price, 0)
                    setValueForComission(totalProdsValueSoldNoPackage)

                    const totalProdsValueSoldNoPackageVeludos = valuesToSave?.filter((data) => !data.devolvido === true && Number(data.id_produto) === 200000)?.reduce((acc, curr) => acc += curr.sell_price, 0)
                    setValueForComissionVeludos(totalProdsValueSoldNoPackageVeludos)

                    const totalProdsValueSoldNoPackageSacolas = valuesToSave?.filter((data) => !data.devolvido === true && Number(data.id_produto) === 200001)?.reduce((acc, curr) => acc += curr.sell_price, 0)
                    setValueForComissionSacolas(totalProdsValueSoldNoPackageSacolas)
                }
            }
        }
    }, [valuesToSave]);

    useEffect(() => {
        if (formType === 'Criando') {
            setValuesToSave([])
            handleChangeActive(false)
            setTotalProds(0)
            setTotalProdsValue(0)
            setAvgTicketKit(0)
        }
    }, []);

    useEffect(() => {
        setIsDirty(false)
    }, []);

    // UPDATING EXISTING KIT
    // let lastIndex = -1; // Track the last updated index globally or outside the function if necessary
    // const handleChangeReturn = useCallback((event) => {
    //     let getId = event
    //     if (event instanceof Object) {
    //         getId = event.target.value
    //     } else {
    //         getId = event
    //     }
    //     setDevIdValue(getId);
    //     if (getId.length === 6) {
    //         setIsDirty(true)
    //         setTimeout(() => {


    //             // const getId = event.target.value;
    //             // console.log('valuesToSave: ', valuesToSave);

    //             // Find the next matching index after the last updated index
    //             const nextIndex = valuesToSave.slice(lastIndexRef.current + 1).findIndex(
    //                 (data) => data.id_produto.toString() === getId.toString() && !data.devolvido === true && !data.sold_prod === true && !data.sold_prod_db === true
    //             );
    //             // console.log('index founded: ', nextIndex)
    //             const checkIfIsAnel = valuesToSave.filter((data) => data.id_produto === getId && !data.sold_prod === true && !data.sold_prod_db === true)
    //             const isAnel = checkIfIsAnel[0]?.model === 'aneis'
    //             console.log('prod return here', checkIfIsAnel)
    //             if (isAnel && checkIfIsAnel.length > 1 && nextIndex !== -1) {
    //                 // Create a table with selectable options
    //                 const optionsTable = `
    //             <table style="width:100%; text-align:left; border-collapse: collapse;">
    //                 <thead>
    //                     <tr>
    //                         <th style="border: 1px solid #ccc; padding: 8px;">ID</th>
    //                         <th style="border: 1px solid #ccc; padding: 8px;">Tamanho</th>
    //                         <th style="border: 1px solid #ccc; padding: 8px;">Selecionar</th>
    //                     </tr>
    //                 </thead>
    //                 <tbody>
    //                     ${checkIfIsAnel
    //                         .map(
    //                             (item) => `
    //                         <tr>
    //                             <td style="border: 1px solid #ccc; padding: 8px;">${item.id_produto}</td>
    //                             <td style="border: 1px solid #ccc; padding: 8px;">${item.tamanho}</td>
    //                             <td style="border: 1px solid #ccc; padding: 8px;">
    //                                 <button 
    //                         class="select-option" 
    //                         data-id="${item.id_produto}-${item.tamanho}" 
    //                         style="padding: 5px 10px; background-color: ${item?.devolvido ? '#ccc' : '#007bff'
    //                                 }; color: #fff; border: none; cursor: ${item?.devolvido ? 'not-allowed' : 'pointer'
    //                                 };"
    //                         ${item?.devolvido ? 'disabled' : ''}
    //                     >
    //                                     Selecionar
    //                                 </button>
    //                             </td>
    //                         </tr>`
    //                         )
    //                         .join('')}
    //                 </tbody>
    //             </table>`;

    //                 // Use SweetAlert2 to show the table
    //                 MySwal.fire({
    //                     title: "Ops!!",
    //                     icon: "question",
    //                     html: `<p>Selecione 1 opção abaixo: </p>${optionsTable}`,
    //                     showConfirmButton: false, // Disable the default "OK" button
    //                     didOpen: () => {
    //                         // Add event listeners to buttons after the modal is rendered
    //                         document.querySelectorAll('.select-option').forEach((button) => {
    //                             button.addEventListener('click', (e) => {
    //                                 const selectedId = e.target.getAttribute('data-id');
    //                                 // console.log("Selected ID:", selectedId);
    //                                 const idProd = selectedId.split('-')[0]
    //                                 const tamanhoProd = selectedId.split('-')[1]
    //                                 const nextIndexAneis = valuesToSave.findIndex(
    //                                     (data) => data.id_produto.toString() === idProd.toString() && !data.devolvido === true && Number(data.tamanho) === Number(tamanhoProd)
    //                                 );
    //                                 // console.log('curr index', nextIndexAneis)
    //                                 const actualIndex = nextIndexAneis;
    //                                 toast.custom(
    //                                     (t) => (
    //                                         <div
    //                                             style={{
    //                                                 padding: "16px",
    //                                                 background: "#e8f5e9", // light green
    //                                                 borderRadius: "12px",
    //                                                 boxShadow: "0 4px 14px rgba(0,0,0,0.2)",
    //                                                 border: "1px solid #4caf50",
    //                                                 // transform: t.visible ? "scale(1)" : "scale(0.95)",
    //                                                 // transition: "all 0.3s ease",
    //                                                 width: "320px",
    //                                                 transform: t.visible ? "translateY(0)" : "translateY(-40px)",
    //                                                 opacity: t.visible ? 1 : 0,
    //                                                 transition: "all 0.4s ease-in-out",
    //                                                 position: "relative",
    //                                                 display: "flex",
    //                                                 flexDirection: "column",
    //                                                 gap: "12px",
    //                                             }}
    //                                         >
    //                                             <button
    //                                                 onClick={() => toast.dismiss(t.id)}
    //                                                 style={{
    //                                                     position: "absolute",
    //                                                     top: 8,
    //                                                     right: 8,
    //                                                     background: "transparent",
    //                                                     border: "none",
    //                                                     cursor: "pointer",
    //                                                     fontSize: "20px",
    //                                                     color: "#4caf50",
    //                                                     fontWeight: "bold",
    //                                                     lineHeight: 1,
    //                                                 }}
    //                                                 aria-label="Fechar"
    //                                                 title="Fechar"
    //                                             >
    //                                                 ×
    //                                             </button>

    //                                             <div style={{ fontSize: 15, color: "black", fontWeight: 'bold', display: 'flex', justifyContent: 'space-between', width: '100%', paddingRight: '20px' }}>
    //                                                 <span>

    //                                                     {checkIfIsAnel[0]?.id_produto}
    //                                                 </span>
    //                                                 <span>

    //                                                     {formatToBRL(checkIfIsAnel[0]?.sell_price)}
    //                                                 </span>
    //                                             </div>
    //                                             <Box
    //                                                 component="img"
    //                                                 src={checkIfIsAnel[0]?.imageUrl ? checkIfIsAnel[0].imageUrl : SemProduto}
    //                                                 alt={"produto"}
    //                                                 // className={styles.smallImage}
    //                                                 onError={(e) => {
    //                                                     e.currentTarget.onerror = null; // impede loop
    //                                                     e.currentTarget.src = SemProduto;
    //                                                 }}
    //                                                 sx={{
    //                                                     width: "100%",
    //                                                     height: "400px",
    //                                                     objectFit: "cover",
    //                                                     borderRadius: "8px",
    //                                                     border: "2px solid #4caf50",
    //                                                 }}
    //                                             />
    //                                         </div>
    //                                     ),
    //                                     {
    //                                         duration: 3000,
    //                                         position: "top-right", // ✅ forces toast to appear top right
    //                                     }
    //                                 );
    //                                 setValuesToSave((prev) => {
    //                                     // Create a new array to avoid mutating state directly
    //                                     const newValues = [...prev];
    //                                     newValues[actualIndex] = {
    //                                         ...newValues[actualIndex],
    //                                         devolvido: true,
    //                                     };

    //                                     return newValues;
    //                                 });

    //                                 // Update lastIndex to the current found index
    //                                 lastIndexRef.current = actualIndex;
    //                                 MySwal.close(); // Close the modal
    //                                 // Use the selected option here (e.g., redirect or update state)
    //                             });
    //                         });
    //                     },
    //                 });
    //             } else {

    //                 if (nextIndex !== -1) {
    //                     // Adjust the index relative to the original array
    //                     const actualIndex = nextIndex + lastIndex + 1;

    //                     toast.custom(
    //                         (t) => (
    //                             <div
    //                                 style={{
    //                                     padding: "16px",
    //                                     background: "#e8f5e9", // light green
    //                                     borderRadius: "12px",
    //                                     boxShadow: "0 4px 14px rgba(0,0,0,0.2)",
    //                                     border: "1px solid #4caf50",
    //                                     // transform: t.visible ? "scale(1)" : "scale(0.95)",
    //                                     // transition: "all 0.3s ease",
    //                                     width: "320px",
    //                                     transform: t.visible ? "translateY(0)" : "translateY(-40px)",
    //                                     opacity: t.visible ? 1 : 0,
    //                                     transition: "all 0.4s ease-in-out",
    //                                     position: "relative",
    //                                     display: "flex",
    //                                     flexDirection: "column",
    //                                     gap: "12px",
    //                                 }}
    //                             >
    //                                 <button
    //                                     onClick={() => toast.dismiss(t.id)}
    //                                     style={{
    //                                         position: "absolute",
    //                                         top: 8,
    //                                         right: 8,
    //                                         background: "transparent",
    //                                         border: "none",
    //                                         cursor: "pointer",
    //                                         fontSize: "20px",
    //                                         color: "#4caf50",
    //                                         fontWeight: "bold",
    //                                         lineHeight: 1,
    //                                     }}
    //                                     aria-label="Fechar"
    //                                     title="Fechar"
    //                                 >
    //                                     ×
    //                                 </button>

    //                                 <div style={{ fontSize: 15, color: "black", fontWeight: 'bold', display: 'flex', justifyContent: 'space-between', width: '100%', paddingRight: '20px' }}>
    //                                     <span>

    //                                         {checkIfIsAnel[0]?.id_produto}
    //                                     </span>
    //                                     <span>

    //                                         {formatToBRL(checkIfIsAnel[0]?.sell_price)}
    //                                     </span>
    //                                 </div>
    //                                 <Box
    //                                     component="img"
    //                                     src={checkIfIsAnel[0]?.imageUrl ? checkIfIsAnel[0].imageUrl : SemProduto}
    //                                     alt={"produto"}
    //                                     // className={styles.smallImage}
    //                                     onError={(e) => {
    //                                         e.currentTarget.onerror = null; // impede loop
    //                                         e.currentTarget.src = SemProduto;
    //                                     }}
    //                                     sx={{
    //                                         width: "100%",
    //                                         height: "400px",
    //                                         objectFit: "cover",
    //                                         borderRadius: "8px",
    //                                         border: "2px solid #4caf50",
    //                                     }}
    //                                 />
    //                             </div>
    //                         ),
    //                         {
    //                             duration: 3000,
    //                             position: "top-right", // ✅ forces toast to appear top right
    //                         }
    //                     );
    //                     setValuesToSave((prev) => {
    //                         // Create a new array to avoid mutating state directly
    //                         const newValues = [...prev];
    //                         newValues[actualIndex] = {
    //                             ...newValues[actualIndex],
    //                             devolvido: true,
    //                         };

    //                         return newValues;
    //                     });

    //                     // Update lastIndex to the current found index
    //                     lastIndexRef.current = actualIndex;
    //                     // console.log("Updated index of: ", actualIndex);
    //                 } else {
    //                     MySwal.fire("Ops!!", `Produto não encontrado: ${getId}`, "error").then(() => {
    //                         // Code to execute after the alert is confirmed
    //                         // For example, redirect to another page or refresh data
    //                     })
    //                 }
    //             }
    //             setTimeout(() => {
    //                 setDevIdValue('');
    //             }, 200);
    //         }, timeOutBipInput);
    //     }
    // },[valuesToSave, setIsDirty, setValuesToSave, MySwal, colors]);

    // const handleChangeReturn = useCallback(
    //     (eventOrId) => {
    //         // Pode vir do TextField (event) ou do botão (id direto)
    //         const fromInput = eventOrId && typeof eventOrId === "object";
    //         const rawId = fromInput ? eventOrId.target?.value : eventOrId;

    //         const getId = String(rawId || "");

    //         // Atualiza o campo só se veio do input
    //         if (fromInput) setDevIdValue(getId);

    //         // Só processa quando tiver 6 dígitos
    //         if (getId.length !== 6) return;

    //         setIsDirty(true);

    //         setTimeout(() => {
    //             const normalized = getId; // aqui não vamos padStart pra não bagunçar códigos

    //             // 🔍 Todos os candidatos com esse ID que ainda podem ser devolvidos
    //             const candidates = valuesToSave
    //                 .map((item, index) => ({ item, index }))
    //                 .filter(
    //                     ({ item }) =>
    //                         String(item.id_produto) === normalized &&
    //                         item.devolvido !== true &&
    //                         item.sold_prod !== true &&
    //                         item.sold_prod_db !== true
    //                 );

    //             if (candidates.length === 0) {
    //                 MySwal.fire(
    //                     "Ops!!",
    //                     `Produto não encontrado: ${normalized}`,
    //                     "error"
    //                 );
    //                 if (fromInput) setTimeout(() => setDevIdValue(""), 200);
    //                 return;
    //             }

    //             const firstCandidate = candidates[0];
    //             const sameIdList = candidates.map((c) => c.item);
    //             const isAnel = sameIdList[0]?.model === "aneis";

    //             // 🟢 CASO: ANEL COM VÁRIOS TAMANHOS
    //             if (isAnel && sameIdList.length > 1) {
    //                 const choices = candidates.map(({ item, index }) => ({
    //                     label: `Tamanho ${item.tamanho ?? "-"}`,
    //                     arrayIndex: index,
    //                 }));

    //                 MySwal.fire({
    //                     title: "Selecione o tamanho para DEVOLUÇÃO",
    //                     input: "select",
    //                     inputOptions: choices.reduce((acc, c, idx) => {
    //                         acc[idx] = c.label;
    //                         return acc;
    //                     }, {}),
    //                     inputPlaceholder: "Escolha",
    //                     showCancelButton: true,
    //                     confirmButtonText: "Confirmar",
    //                     cancelButtonText: "Cancelar",
    //                 }).then((result) => {
    //                     if (!result.isConfirmed) return;

    //                     const chosen = choices[result.value];
    //                     if (chosen.arrayIndex === undefined) return;

    //                     setValuesToSave((prev) => {
    //                         const arr = [...prev];
    //                         const idx = chosen.arrayIndex;
    //                         const item = arr[idx];

    //                         arr[idx] = {
    //                             ...item,
    //                             devolvido: true,
    //                         };

    //                         // ✅ Toast com imagem
    //                         toast.custom(
    //                             (t) => (
    //                                 <div
    //                                     style={{
    //                                         padding: "16px",
    //                                         background: "#e8f5e9",
    //                                         borderRadius: "12px",
    //                                         boxShadow:
    //                                             "0 4px 14px rgba(0,0,0,0.2)",
    //                                         border: "1px solid #4caf50",
    //                                         width: "320px",
    //                                         transform: t.visible
    //                                             ? "translateY(0)"
    //                                             : "translateY(-40px)",
    //                                         opacity: t.visible ? 1 : 0,
    //                                         transition: "all 0.4s ease-in-out",
    //                                         position: "relative",
    //                                         display: "flex",
    //                                         flexDirection: "column",
    //                                         gap: "12px",
    //                                     }}
    //                                 >
    //                                     <button
    //                                         onClick={() => toast.dismiss(t.id)}
    //                                         style={{
    //                                             position: "absolute",
    //                                             top: 8,
    //                                             right: 8,
    //                                             background: "transparent",
    //                                             border: "none",
    //                                             cursor: "pointer",
    //                                             fontSize: "20px",
    //                                             color: "#4caf50",
    //                                             fontWeight: "bold",
    //                                             lineHeight: 1,
    //                                         }}
    //                                         aria-label="Fechar"
    //                                         title="Fechar"
    //                                     >
    //                                         ×
    //                                     </button>

    //                                     <div
    //                                         style={{
    //                                             fontSize: 15,
    //                                             color: "black",
    //                                             fontWeight: "bold",
    //                                             display: "flex",
    //                                             justifyContent: "space-between",
    //                                             width: "100%",
    //                                             paddingRight: "20px",
    //                                         }}
    //                                     >
    //                                         <span>{item.id_produto}</span>
    //                                         <span>
    //                                             {formatToBRL(item.sell_price)}
    //                                         </span>
    //                                     </div>

    //                                     <Box
    //                                         component="img"
    //                                         src={
    //                                             item.imageUrl
    //                                                 ? item.imageUrl
    //                                                 : SemProduto
    //                                         }
    //                                         alt={"produto"}
    //                                         onError={(e) => {
    //                                             e.currentTarget.onerror = null;
    //                                             e.currentTarget.src = SemProduto;
    //                                         }}
    //                                         sx={{
    //                                             width: "100%",
    //                                             height: "400px",
    //                                             objectFit: "cover",
    //                                             borderRadius: "8px",
    //                                             border: "2px solid #4caf50",
    //                                         }}
    //                                     />
    //                                 </div>
    //                             ),
    //                             {
    //                                 duration: 3000,
    //                                 position: "top-right",
    //                             }
    //                         );

    //                         return arr;
    //                     });
    //                 });
    //             } else {
    //                 // 🟠 CASO NORMAL: pega o primeiro elegível
    //                 setValuesToSave((prev) => {
    //                     const arr = [...prev];
    //                     const idx = firstCandidate.index;
    //                     const item = arr[idx];

    //                     arr[idx] = {
    //                         ...item,
    //                         devolvido: true,
    //                     };

    //                     toast.custom(
    //                         (t) => (
    //                             <div
    //                                 style={{
    //                                     padding: "16px",
    //                                     background: "#e8f5e9",
    //                                     borderRadius: "12px",
    //                                     boxShadow:
    //                                         "0 4px 14px rgba(0,0,0,0.2)",
    //                                     border: "1px solid #4caf50",
    //                                     width: "320px",
    //                                     transform: t.visible
    //                                         ? "translateY(0)"
    //                                         : "translateY(-40px)",
    //                                     opacity: t.visible ? 1 : 0,
    //                                     transition: "all 0.4s ease-in-out",
    //                                     position: "relative",
    //                                     display: "flex",
    //                                     flexDirection: "column",
    //                                     gap: "12px",
    //                                 }}
    //                             >
    //                                 <button
    //                                     onClick={() => toast.dismiss(t.id)}
    //                                     style={{
    //                                         position: "absolute",
    //                                         top: 8,
    //                                         right: 8,
    //                                         background: "transparent",
    //                                         border: "none",
    //                                         cursor: "pointer",
    //                                         fontSize: "20px",
    //                                         color: "#4caf50",
    //                                         fontWeight: "bold",
    //                                         lineHeight: 1,
    //                                     }}
    //                                     aria-label="Fechar"
    //                                     title="Fechar"
    //                                 >
    //                                     ×
    //                                 </button>

    //                                 <div
    //                                     style={{
    //                                         fontSize: 15,
    //                                         color: "black",
    //                                         fontWeight: "bold",
    //                                         display: "flex",
    //                                         justifyContent: "space-between",
    //                                         width: "100%",
    //                                         paddingRight: "20px",
    //                                     }}
    //                                 >
    //                                     <span>{item.id_produto}</span>
    //                                     <span>
    //                                         {formatToBRL(item.sell_price)}
    //                                     </span>
    //                                 </div>

    //                                 <Box
    //                                     component="img"
    //                                     src={
    //                                         item.imageUrl
    //                                             ? item.imageUrl
    //                                             : SemProduto
    //                                     }
    //                                     alt={"produto"}
    //                                     onError={(e) => {
    //                                         e.currentTarget.onerror = null;
    //                                         e.currentTarget.src = SemProduto;
    //                                     }}
    //                                     sx={{
    //                                         width: "100%",
    //                                         height: "400px",
    //                                         objectFit: "cover",
    //                                         borderRadius: "8px",
    //                                         border: "2px solid #4caf50",
    //                                     }}
    //                                 />
    //                             </div>
    //                         ),
    //                         {
    //                             duration: 3000,
    //                             position: "top-right",
    //                         }
    //                     );

    //                     return arr;
    //                 });
    //             }

    //             if (fromInput) setTimeout(() => setDevIdValue(""), 200);
    //         }, timeOutBipInput);
    //     },
    //     [valuesToSave, setIsDirty, setValuesToSave, MySwal, setDevIdValue]
    // );

    const showReturnToast = useCallback((item) => {
        const toastId = `return-${item.unit_id || item.id_produto}`;

        toast.custom(
            (t) => (
                <div
                    style={{
                        padding: "16px",
                        background: "#e8f5e9",
                        borderRadius: "12px",
                        boxShadow: "0 4px 14px rgba(0,0,0,0.2)",
                        border: "1px solid #4caf50",
                        width: "320px",
                        transform: t.visible ? "translateY(0)" : "translateY(-40px)",
                        opacity: t.visible ? 1 : 0,
                        transition: "all 0.4s ease-in-out",
                        position: "relative",
                        display: "flex",
                        flexDirection: "column",
                        gap: "12px",
                    }}
                >
                    <button
                        onClick={() => toast.dismiss(toastId)}
                        style={{
                            position: "absolute",
                            top: 8,
                            right: 8,
                            background: "transparent",
                            border: "none",
                            cursor: "pointer",
                            fontSize: "20px",
                            color: "#4caf50",
                            fontWeight: "bold",
                            lineHeight: 1,
                        }}
                        aria-label="Fechar"
                        title="Fechar"
                    >
                        ×
                    </button>

                    <div
                        style={{
                            fontSize: 15,
                            color: "black",
                            fontWeight: "bold",
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                            paddingRight: "20px",
                        }}
                    >
                        <span>{item.id_produto}</span>
                        <span>{formatToBRL(item.sell_price)}</span>
                    </div>

                    <Box
                        component="img"
                        src={item.imageUrl ? item.imageUrl : SemProduto}
                        alt={"produto"}
                        onError={(e) => {
                            e.currentTarget.onerror = null;
                            e.currentTarget.src = SemProduto;
                        }}
                        sx={{
                            width: "100%",
                            height: "400px",
                            objectFit: "cover",
                            borderRadius: "8px",
                            border: "2px solid #4caf50",
                        }}
                    />
                </div>
            ),
            {
                id: toastId,              // ✅ chave única por unidade
                duration: 3000,
                position: "top-right",
            }
        );
    }, []);


    // const showReturnToast =(item) => console.log('item', item)



    const handleChangeReturn = useCallback(
        (eventOrId, unitId) => {
            // =====================================================
            // 1) CLIQUE NA LINHA → unit_id (prioridade absoluta)
            // =====================================================
            if (unitId) {
                setIsDirty(true);

                setValuesToSave((prev) => {
                    const idx = prev.findIndex((x) => x.unit_id === unitId);
                    if (idx === -1) return prev;

                    const item = prev[idx];
                    if (item.devolvido || item.sold_prod || item.sold_prod_db) return prev;

                    const arr = [...prev];
                    arr[idx] = { ...item, devolvido: true };

                    // ✅ TOAST IMEDIATO (igual ao antigo)
                    showReturnToast(item);

                    return arr;
                });

                return;
            }

            // =====================================================
            // 2) SCANNER / INPUT / CHAMADA ANTIGA POR id_produto
            // =====================================================
            const fromInput = !!(eventOrId && typeof eventOrId === "object" && eventOrId.target);
            const rawId = fromInput ? eventOrId.target.value : eventOrId;
            const getId = String(rawId || "");

            if (fromInput) setDevIdValue(getId);
            if (getId.length !== 6) return;

            setIsDirty(true);

            setTimeout(() => {
                setValuesToSave((prev) => {
                    const candidates = prev.filter(
                        (item) =>
                            String(item.id_produto) === getId &&
                            !item.devolvido &&
                            !item.sold_prod &&
                            !item.sold_prod_db
                    );

                    if (candidates.length === 0) {
                        MySwal.fire("Ops!!", `Produto não encontrado: ${getId}`, "error");
                        if (fromInput) setTimeout(() => setDevIdValue(""), 200);
                        return prev;
                    }

                    const first = candidates[0];
                    const isAnel = first.model === "aneis";

                    // =================================================
                    // 2.1) ANEL COM VÁRIOS TAMANHOS → SELECT
                    // =================================================
                    if (isAnel && candidates.length > 1) {
                        const choices = candidates.map((item) => ({
                            label: `Tamanho ${item.tamanho ?? "-"}`,
                            unit_id: item.unit_id,
                        }));

                        MySwal.fire({
                            title: "Selecione o tamanho para DEVOLUÇÃO",
                            input: "select",
                            inputOptions: choices.reduce((acc, c, i) => {
                                acc[i] = c.label;
                                return acc;
                            }, {}),
                            inputPlaceholder: "Escolha",
                            showCancelButton: true,
                            confirmButtonText: "Confirmar",
                            cancelButtonText: "Cancelar",
                        }).then((result) => {
                            if (!result.isConfirmed) return;

                            const chosen = choices[Number(result.value)];
                            if (!chosen?.unit_id) return;

                            setValuesToSave((p2) => {
                                const idx2 = p2.findIndex((x) => x.unit_id === chosen.unit_id);
                                if (idx2 === -1) return p2;

                                const it2 = p2[idx2];
                                if (it2.devolvido || it2.sold_prod || it2.sold_prod_db) return p2;

                                const arr2 = [...p2];
                                arr2[idx2] = { ...it2, devolvido: true };

                                // ✅ TOAST IMEDIATO
                                showReturnToast(it2);

                                return arr2;
                            });
                        });

                        if (fromInput) setTimeout(() => setDevIdValue(""), 200);
                        return prev;
                    }

                    // =================================================
                    // 2.2) CASO NORMAL → devolve direto + toast
                    // =================================================
                    const item = first;
                    const idx = prev.findIndex((x) => x.unit_id === item.unit_id);
                    if (idx === -1) return prev;

                    const arr = [...prev];
                    arr[idx] = { ...item, devolvido: true };

                    // ✅ TOAST IMEDIATO
                    showReturnToast(item);

                    if (fromInput) setTimeout(() => setDevIdValue(""), 200);
                    return arr;
                });
            }, timeOutBipInput);
        },
        [
            setIsDirty,
            setValuesToSave,
            MySwal,
            setDevIdValue,
        ]
    );



    // const handleChangeSoldProd = useCallback((event) => {
    //     let getId = event
    //     if (event instanceof Object) {
    //         getId = event.target.value
    //     } else {
    //         getId = event
    //     }
    //     if (getId.length === 6) {
    //         setTimeout(() => {
    //             setIsDirty(true)


    //             // const getId = event.target.value;
    //             // console.log('valuesToSave: ', valuesToSave);

    //             // Find the next matching index after the last updated index
    //             const nextIndex = valuesToSave.slice(lastIndexRef.current + 1).findIndex(
    //                 (data) => data.id_produto.toString() === getId.toString() && !data.sold_prod === true
    //             );
    //             // console.log('index founded: ', nextIndex)
    //             const checkIfIsAnel = valuesToSave.filter((data) => data.id_produto === getId)
    //             const isAnel = checkIfIsAnel[0]?.model === 'aneis'
    //             if (isAnel && checkIfIsAnel.length > 1 && nextIndex !== -1) {
    //                 // Create a table with selectable options
    //                 const optionsTable = `
    //             <table style="width:100%; text-align:left; border-collapse: collapse;">
    //                 <thead>
    //                     <tr>
    //                         <th style="border: 1px solid #ccc; padding: 8px;">ID</th>
    //                         <th style="border: 1px solid #ccc; padding: 8px;">Tamanho</th>
    //                         <th style="border: 1px solid #ccc; padding: 8px;">Selecionar</th>
    //                     </tr>
    //                 </thead>
    //                 <tbody>
    //                     ${checkIfIsAnel
    //                         .map(
    //                             (item) => `
    //                         <tr>
    //                             <td style="border: 1px solid #ccc; padding: 8px;">${item.id_produto}</td>
    //                             <td style="border: 1px solid #ccc; padding: 8px;">${item.tamanho}</td>
    //                             <td style="border: 1px solid #ccc; padding: 8px;">
    //                                 <button 
    //                         class="select-option" 
    //                         data-id="${item.id_produto}-${item.tamanho}" 
    //                         style="padding: 5px 10px; background-color: ${item?.sold_prod ? '#ccc' : '#007bff'
    //                                 }; color: #fff; border: none; cursor: ${item?.sold_prod ? 'not-allowed' : 'pointer'
    //                                 };"
    //                         ${item?.sold_prod ? 'disabled' : ''}
    //                     >
    //                                     Selecionar
    //                                 </button>
    //                             </td>
    //                         </tr>`
    //                         )
    //                         .join('')}
    //                 </tbody>
    //             </table>`;

    //                 // Use SweetAlert2 to show the table
    //                 MySwal.fire({
    //                     title: "Ops!!",
    //                     icon: "question",
    //                     html: `<p>Selecione 1 opção abaixo: </p>${optionsTable}`,
    //                     showConfirmButton: false, // Disable the default "OK" button
    //                     didOpen: () => {
    //                         // Add event listeners to buttons after the modal is rendered
    //                         document.querySelectorAll('.select-option').forEach((button) => {
    //                             button.addEventListener('click', (e) => {
    //                                 const selectedId = e.target.getAttribute('data-id');
    //                                 // console.log("Selected ID:", selectedId);
    //                                 const idProd = selectedId.split('-')[0]
    //                                 const tamanhoProd = selectedId.split('-')[1]
    //                                 const nextIndexAneis = valuesToSave.findIndex(
    //                                     (data) => data.id_produto.toString() === idProd.toString() && !data.sold_prod === true && Number(data.tamanho) === Number(tamanhoProd)
    //                                 );
    //                                 // console.log('curr index', nextIndexAneis)
    //                                 const actualIndex = nextIndexAneis;
    //                                 setValuesToSave((prev) => {
    //                                     // Create a new array to avoid mutating state directly
    //                                     const newValues = [...prev];
    //                                     newValues[actualIndex] = {
    //                                         ...newValues[actualIndex],
    //                                         sold_prod: true,
    //                                     };

    //                                     return newValues;
    //                                 });

    //                                 // Update lastIndex to the current found index
    //                                 lastIndexRef.current = actualIndex;
    //                                 MySwal.close(); // Close the modal
    //                                 // Use the selected option here (e.g., redirect or update state)
    //                             });
    //                         });
    //                     },
    //                 });
    //             } else {

    //                 if (nextIndex !== -1) {
    //                     // Adjust the index relative to the original array
    //                     const actualIndex = nextIndex + lastIndex + 1;

    //                     setValuesToSave((prev) => {
    //                         // Create a new array to avoid mutating state directly
    //                         const newValues = [...prev];
    //                         newValues[actualIndex] = {
    //                             ...newValues[actualIndex],
    //                             sold_prod: true,
    //                         };

    //                         return newValues;
    //                     });

    //                     // Update lastIndex to the current found index
    //                     lastIndex = actualIndex;
    //                     // console.log("Updated index of: ", actualIndex);
    //                 } else {
    //                     MySwal.fire("Ops!!", `Produto não encontrado: ${getId}`, "error").then(() => {
    //                         // Code to execute after the alert is confirmed
    //                         // For example, redirect to another page or refresh data
    //                     })
    //                 }
    //             }
    //         }, timeOutBipInput);
    //     }
    // }, [valuesToSave, setIsDirty, setValuesToSave, MySwal]);

    const handleChangeSoldProd = useCallback(
        (unitId) => {
            if (!unitId) return;

            setIsDirty(true);

            setTimeout(() => {
                setValuesToSave((prev) => {
                    const idx = prev.findIndex((x) => x.unit_id === unitId);
                    if (idx === -1) return prev;

                    const item = prev[idx];

                    // ✅ não vender devolvido
                    if (item.devolvido === true) return prev;

                    // ✅ já vendido (front ou db)
                    if (item.sold_prod === true || item.sold_prod_db === true) return prev;

                    const arr = [...prev];
                    arr[idx] = { ...item, sold_prod: true };
                    return arr;
                });
            }, timeOutBipInput);
        },
        [setIsDirty, setValuesToSave]
    );




    // const handleRemoveDevolvido = useCallback((data) => {
    //     setIsDirty(true)
    //     const id = data.id_produto
    //     const { tamanho } = data
    //     setValuesToSave((prev) => {
    //         // Create a new array to avoid mutating state directly
    //         const newValues = [...prev];
    //         let indexToUpdate;
    //         // Find the index of the next occurrence of the item with the specified ID and 'devolvido' set to true
    //         if (tamanho) {
    //             indexToUpdate = newValues.findIndex(
    //                 (item, index) =>
    //                     item.id_produto.toString() === id.toString() && (item.devolvido === true || item.sold_prod === true || item.sold_prod_db === true) && Number(item.tamanho) === Number(tamanho)
    //             );
    //         } else {

    //             indexToUpdate = newValues.findIndex(
    //                 (item, index) =>
    //                     item.id_produto.toString() === id.toString() && (item.devolvido === true || item.sold_prod === true || item.sold_prod_db === true)
    //             );
    //         }

    //         // If we found a match, remove the 'devolvido' property
    //         if (indexToUpdate !== -1) {
    //             const { devolvido, sold_prod, sold_prod_db, ...updatedItem } = newValues[indexToUpdate]; // Remove 'devolvido' key
    //             if (sold_prod_db) {
    //                 newValues[indexToUpdate] = {
    //                     ...updatedItem,
    //                     sold_prod_db: false
    //                 }
    //             } else {
    //                 newValues[indexToUpdate] = updatedItem;
    //             }
    //         } else {
    //             console.log(`No 'devolvido' item found with ID: ${id}`);
    //         }

    //         return newValues;
    //     });
    // }, [setIsDirty, setValuesToSave]);

    const handleRemoveDevolvido = useCallback(
        (unitId) => {
            if (!unitId) return;

            setIsDirty(true);

            setValuesToSave((prev) => {
                const idx = prev.findIndex((x) => x.unit_id === unitId);
                if (idx === -1) {
                    console.log(`No item found with unit_id: ${unitId}`);
                    return prev;
                }

                const curr = prev[idx];

                // remove flags locais e/ou do db
                const { devolvido, sold_prod, sold_prod_db, ...rest } = curr;

                const arr = [...prev];

                // se estava marcado no DB, só “desmarca” o db (mantém item)
                if (sold_prod_db) {
                    arr[idx] = {
                        ...rest,
                        devolvido: false,
                        sold_prod: false,
                        sold_prod_db: false,
                    };
                } else {
                    // se era devolvido/sold só no front, zera flags
                    arr[idx] = {
                        ...rest,
                        devolvido: false,
                        sold_prod: false,
                        sold_prod_db: false,
                    };
                }

                return arr;
            });
        },
        [setIsDirty, setValuesToSave]
    );


    // HANDLE CHANGE FOR NEW KIT
    const handleChange = useCallback((event) => {
        setValue(event.target.value);
        if (event.target.value.length === 6) {
            setIsDirty(true)
            setTimeout(() => {
                console.log('value: ', event.target.value)
                const getId = event.target.value
                const getValue = findProductsHandlerdById(getId, productsData)

                if (getValue?.length > 0) {
                    console.log('valueHere: ', getValue)
                    const objToAdd = getValue[0]
                    const { model } = objToAdd
                    // TODO
                    //CRIAR LOGICA PARA INSERIR O TAMANHO
                    let instanceToAd = {
                        ...objToAdd, sell_price: objToAdd.charged_price, added_now: true
                    }
                    if (model === 'aneis') {
                        MySwal.fire({
                            title: "Atenção!!",
                            html: `Insira o tamanho do Anel`,
                            icon: "question",
                            input: "number",  // Input type set to 'number'
                            inputAttributes: {
                                min: 0,         // Minimum value
                                max: 100,       // Maximum value
                                step: 1         // Step increment
                            },
                            showCancelButton: true,
                            confirmButtonText: "Confirmar",
                            cancelButtonText: "Cancelar",
                            reverseButtons: true,
                            confirmButtonColor: colors.greenAccent[500],
                            cancelButtonColor: colors.yellow[600],
                            customClass: {
                                confirmButton: styles['custom-confirm-button'],
                                cancelButton: styles['custom-cancel-button'],
                                actions: styles['custom-actions'],
                            },
                            didOpen: () => {
                                // Disable the confirm button initially
                                const confirmButton = MySwal.getConfirmButton();
                                confirmButton.disabled = true;

                                // Add an event listener to the input to enable the confirm button when valid
                                const input = MySwal.getInput();
                                input.addEventListener("input", () => {
                                    if (input.value && input.value >= 0 && input.value <= 100) {
                                        confirmButton.disabled = false; // Enable the button if the input is valid
                                    } else {
                                        confirmButton.disabled = true; // Disable if invalid
                                    }
                                });
                            },
                        }).then((result) => {
                            if (result.isConfirmed) {
                                const inputValue = result.value; // The entered value is available in result.value
                                if (inputValue < 0 || inputValue > 100) {
                                    // Optionally validate again (SweetAlert already enforces min/max)
                                    console.error('Invalid value');
                                    return;
                                }
                                console.log('Value entered:', inputValue);
                                instanceToAd = {
                                    ...instanceToAd, tamanho: inputValue
                                }
                                //LOGIC TO CHECK IF THE PRODUCT HAS BEEN IN THE PREVIOUS KIT FOR THIS SELLER
                                // #TODO
                                const findIfHasBenn = findProdByIdHasBefore(sellersKits, getId)
                                console.log('produto encontrado: ', findIfHasBenn)
                                if (findIfHasBenn.length > 0) {
                                    const tableHTML = ReactDOMServer.renderToString(<TableComponent data={findIfHasBenn} />);
                                    MySwal.fire({
                                        title: "Ops!!",
                                        html: `Produto${findIfHasBenn.length > 1 ? 's' : ''} encontrado${findIfHasBenn.length > 1 ? 's' : ''} para o id<br /> <b>${getId}</b> <br />` + tableHTML,
                                        icon: "question",   // Shows the blue question mark icon
                                        showCancelButton: true,
                                        confirmButtonText: "Sim",
                                        cancelButtonText: "Não",
                                        reverseButtons: true,  // Swaps the order of buttons
                                        confirmButtonColor: colors.greenAccent[500],  // Set your desired color
                                        cancelButtonColor: colors.yellow[600],      // Set your desired color
                                        customClass: {
                                            confirmButton: styles['custom-confirm-button'],
                                            cancelButton: styles['custom-cancel-button'],
                                            actions: styles['custom-actions'],
                                        },
                                    }).then((result) => {
                                        if (result.isConfirmed) {
                                            // Code to execute if Confirm is pressed
                                            setValuesToSave((prevValues) => {
                                                return [instanceToAd, ...prevValues]
                                            })
                                            toast.success(
                                                `Produto: ${getId} incluído com sucesso!!`,
                                                {
                                                    position: 'top-right'
                                                }
                                            );
                                        } else if (result.isDismissed) {
                                            // Code to execute if Cancel is pressed
                                            console.log('nao faz nada')
                                            return
                                        }
                                    });
                                } else {
                                    setValuesToSave((prevValues) => {
                                        return [instanceToAd, ...prevValues]
                                    })
                                    toast.success(
                                        `Produto: ${getId} incluído com sucesso!!`,
                                        {
                                            position: 'top-right'
                                        }
                                    );
                                }
                            } else if (result.isDismissed) {
                                console.log('Cancelled, no action taken');
                            }
                        });
                    } else {


                        //LOGIC TO CHECK IF THE PRODUCT HAS BEEN IN THE PREVIOUS KIT FOR THIS SELLER
                        // #TODO
                        const findIfHasBenn = findProdByIdHasBefore(sellersKits, getId)
                        console.log('produto encontrado: ', findIfHasBenn)
                        if (findIfHasBenn.length > 0) {
                            const tableHTML = ReactDOMServer.renderToString(<TableComponent data={findIfHasBenn} />);
                            MySwal.fire({
                                title: "Ops!!",
                                html: `Produto${findIfHasBenn.length > 1 ? 's' : ''} encontrado${findIfHasBenn.length > 1 ? 's' : ''} para o id<br /> <b>${getId}</b> <br />` + tableHTML,
                                icon: "question",   // Shows the blue question mark icon
                                showCancelButton: true,
                                confirmButtonText: "Sim",
                                cancelButtonText: "Não",
                                reverseButtons: true,  // Swaps the order of buttons
                                confirmButtonColor: colors.greenAccent[500],  // Set your desired color
                                cancelButtonColor: colors.yellow[600],      // Set your desired color
                                customClass: {
                                    confirmButton: styles['custom-confirm-button'],
                                    cancelButton: styles['custom-cancel-button'],
                                    actions: styles['custom-actions'],
                                },
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    // Code to execute if Confirm is pressed
                                    setValuesToSave((prevValues) => {
                                        return [instanceToAd, ...prevValues]
                                    })
                                    toast.success(
                                        `Produto: ${getId} incluído com sucesso!!`,
                                        {
                                            position: 'top-right'
                                        }
                                    );
                                } else if (result.isDismissed) {
                                    // Code to execute if Cancel is pressed
                                    console.log('nao faz nada')
                                    return
                                }
                            });
                        } else {
                            setValuesToSave((prevValues) => {
                                return [instanceToAd, ...prevValues]
                            })
                            toast.success(
                                `Produto: ${getId} incluído com sucesso!!`,
                                {
                                    position: 'top-right'
                                }
                            );
                        }
                    }
                } else {
                    MySwal.fire("Ops!!", `Produto não encontrado: ${getId}`, "error").then(() => {
                        // Code to execute after the alert is confirmed
                        // For example, redirect to another page or refresh data
                    })
                }
                setTimeout(() => {
                    setValue('')
                }, 200);
            }, timeOutBipInput);
        }
    }, [setIsDirty, setValuesToSave, productsData, sellersKits, MySwal, colors]);

    const prodHandler = useCallback((type, id) => {
        setIsDirty(true)
        if (type === 'add') {
            console.log('add ID: ', id)
            setValuesToSave((prevValues) => {
                // Find the index of the item with the same id as selectedProd[0]
                const existingItemIndex = prevValues.findIndex(
                    (item) => item.id_produto === id
                );
                if (existingItemIndex !== -1) {
                    // If item exists, create a new array with the updated quantity
                    const updatedValues = prevValues.map((item, index) =>
                        index === existingItemIndex
                            ? { ...item, quantity: item.quantity + 1 }
                            : item
                    );
                    return updatedValues;
                }
            });
        } else if (type === 'remove') {
            console.log('remove ID: ', id)
            setValuesToSave((prevValues) => {
                // Find the index of the item with the same id as selectedProd[0]
                const existingItemIndex = prevValues.findIndex(
                    (item) => item.id_produto === id
                );

                if (existingItemIndex !== -1) {
                    // If item exists, create a new array with the updated quantity
                    const updatedValues = prevValues.map((item, index) =>
                        index === existingItemIndex
                            ? { ...item, quantity: item.quantity - 1 }
                            : item
                    );
                    return updatedValues;
                }
            });
            toast.success(
                `Produto: ${id} Removido com sucesso!!`,
                {
                    position: 'top-center'
                }
            );
        } else if (type === 'delete') {
            setValuesToSave((prevValues) => {
                // Find the index of the item with the same id as selectedProd[0]
                const existingItemIndex = prevValues.findIndex(
                    (item) => item.id_produto === id
                );
                if (existingItemIndex !== -1) {
                    return [
                        ...prevValues.slice(0, existingItemIndex),
                        ...prevValues.slice(existingItemIndex + 1)
                    ];
                }
                // If the item is not found, return the original array
                return prevValues;
            });
            toast.success(
                `Produto: ${id} Removido com sucesso!!`,
                {
                    position: 'top-center'
                }
            );
        } else if (type === 'deleteEdited') {
            setValuesToSave((prevValues) => {
                // Find the index of the item with the same id as selectedProd[0]
                const existingItemIndex = prevValues.findIndex(
                    (item) => item.id_produto === id && item.id_supplier !== (undefined || null)
                );
                if (existingItemIndex !== -1) {
                    return [
                        ...prevValues.slice(0, existingItemIndex),
                        ...prevValues.slice(existingItemIndex + 1)
                    ];
                }
                // If the item is not found, return the original array
                return prevValues;
            });
            toast.success(
                `Produto: ${id} Removido com sucesso!!`,
                {
                    position: 'top-center'
                }
            );
        }
    }, [setIsDirty, setValuesToSave])

    const handleChangeDate = (value) => {
        setIsDirty(true)
        setInitialDate(value)
        console.log("value", value)
    }

    const handleClick = async () => {
        setLoadingBtnImg(true);
        try {
            await generateImagesPDF(imgToPrintArr, sellersKits);
        } catch (err) {
            console.error(err);
        }
        setLoadingBtnImg(false);
    };


    const sortedValues = useMemo(() => {
        if (!valuesToSave || valuesToSave.length === 0) return [];

        if (!orderByNumber) return valuesToSave;

        return [...valuesToSave].sort((b, a) =>
            String(b.id_produto).localeCompare(String(a.id_produto), "pt", { numeric: true })
        );
    }, [valuesToSave, orderByNumber]);


    const isCaseRequiredError =
        formType === "Criando" &&
        valuesToSave?.length > 0 &&
        !caseType;


    if (isLoading) {
        return (
            <Box
                sx={{
                    height: '720px',
                    width: '100%',
                    padding: '10px',
                    backgroundColor: colors.pink[700],
                    borderRadius: '4px',
                    display: 'flex',
                    flexDirection: 'column'
                }}
            >
                <FormKitPageSkeleton />
            </Box>
        );
    }



    return (
        <>
            {
                notes && notes?.length > 0 &&
                <Box mt={1} mb={1} pl={1}>
                    <Typography variant="body2" >
                        <strong>Observações pelo app: </strong>{" "}&nbsp;
                        {notes
                            .map((item) => ` • ${item.note}`)
                            .join(" | ")}
                    </Typography>
                </Box>
            }
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'row-reverse',
                    width: '100%',
                    gap: '20px',
                    alignItems: 'stretch'
                }}
            >
                {
                    valuesToSave && valuesToSave.length > 0 &&

                    <Box
                        display={"flex"}
                        flexDirection={"row"}
                        justifyContent={"space-between"}
                        gap={"20px"}
                        alignItems={"stretch"}
                    >

                        <Paper
                            elevation={6}
                            sx={{
                                backgroundColor: colors.pink[600],
                                width: '300px',
                                display: 'flex',
                                flexDirection: 'column',
                                alignSelf: 'stretch',
                                height: '100%'
                                // backgroundColor: theme.palette.mode === "light" && colors.primary[900]
                            }}
                        >
                            <CardContent sx={{ paddingBottom: "16px !important" }}>
                                <Box
                                    sx={{
                                        display: 'grid',
                                        gridTemplateColumns: '1fr 1fr 0.75fr',
                                        width: '100%',
                                        gap: 1,
                                        alignItems: 'stretch',
                                    }}
                                >
                                    <Box
                                        sx={{
                                            textAlign: 'center',
                                            px: 0.75,
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'center',
                                        }}
                                    >
                                        <Typography variant="caption" sx={{ opacity: 0.75, fontWeight: 700 }}>
                                            Valor Total
                                        </Typography>
                                        <Typography variant="body1" fontWeight="bold">
                                            R$ {formatNumber(totalProdsValue)}
                                        </Typography>
                                    </Box>

                                    <Box
                                        sx={{
                                            textAlign: 'center',
                                            px: 0.75,
                                            borderLeft: '1px solid rgba(255,255,255,0.18)',
                                            borderRight: '1px solid rgba(255,255,255,0.18)',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'center',
                                        }}
                                    >
                                        <Typography variant="caption" sx={{ opacity: 0.75, fontWeight: 700 }}>
                                            Ticket Médio
                                        </Typography>
                                        <Typography variant="body1" fontWeight="bold">
                                            R$ {formatNumber(avgTicketKit)}
                                        </Typography>
                                    </Box>

                                    <Box
                                        sx={{
                                            textAlign: 'center',
                                            px: 0.5,
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'center',
                                        }}
                                    >
                                        <Typography
                                            variant="caption"
                                            sx={{
                                                opacity: 0.75,
                                                fontWeight: 700,
                                                fontSize: '0.68rem',
                                            }}
                                        >
                                            Quantidade
                                        </Typography>

                                        <Typography
                                            variant="body2"
                                            fontWeight="bold"
                                            sx={{
                                                fontSize: '0.95rem',
                                                lineHeight: 1.1,
                                                mt: 0.25,
                                            }}
                                        >
                                            {totalProds}
                                        </Typography>
                                    </Box>
                                </Box>
                            </CardContent>
                            <Divider />
                            <CardContent sx={{ padding: '10px' }}>
                                <Typography variant="h6" fontWeight={"bold"}>
                                    Produtos
                                </Typography>
                                <Box>
                                    {
                                        [...totalProdsOnKitByModel].sort((a, b) => a.model.localeCompare(b.model)).map((data, index) => {
                                            return (
                                                <>
                                                    <Box key={data?.object_id} style={{ padding: 0, margin: 0, width: '100%' }}>
                                                        <Box style={{ display: "flex", gap: "10px", justifyContent: 'space-between' }}>
                                                            <Typography variant="h6" style={{ minWidth: '100px', maxWidth: '100px' }}>{data.model}</Typography>
                                                            <Typography variant="h6" style={{ width: '50px', display: "inline-block" }}>{data.quantity}</Typography>
                                                            <Typography variant="h6" style={{ width: '100px', display: "inline-block" }}>R$ {formatNumber(data.sell_price)}</Typography>
                                                        </Box>
                                                    </Box>
                                                    <Divider />
                                                </>

                                            )
                                        })
                                    }
                                </Box>
                            </CardContent>
                            <Divider />
                            <CardContent sx={{ padding: '10px' }}>
                                <Typography variant="h6" fontWeight={"bold"} mb={1}>
                                    Cores da Maleta
                                </Typography>

                                {totalProdsOnKitByColor.length > 0 ? (
                                    <>
                                        <Box sx={{ width: '100%', height: 220 }}>
                                            <ResponsiveContainer width="100%" height="100%">
                                                <PieChart>
                                                    <Pie
                                                        data={totalProdsOnKitByColor}
                                                        dataKey="quantity"
                                                        nameKey="name"
                                                        cx="50%"
                                                        cy="50%"
                                                        outerRadius={72}
                                                        label={({ payload }) => `${payload?.quantity ?? 0} • ${formatPercentBR(payload?.percent)}%`}
                                                    >
                                                        {totalProdsOnKitByColor.map((entry, index) => (
                                                            <Cell
                                                                key={`cell-${index}`}
                                                                fill={PIE_COLORS[index % PIE_COLORS.length]}
                                                            />
                                                        ))}
                                                    </Pie>
                                                    <RechartsTooltip
                                                        formatter={(value, name, props) => [
                                                            `${value} peça(s) • ${formatPercentBR(props?.payload?.percent)}%`,
                                                            name,
                                                        ]}
                                                    />
                                                    <Legend />
                                                </PieChart>
                                            </ResponsiveContainer>
                                        </Box>

                                        <Box mt={1}>
                                            {[...totalProdsOnKitByColor]
                                                .sort((a, b) => b.quantity - a.quantity)
                                                .map((item, index) => (
                                                    <Box key={`${item.name}-${index}`} sx={{ py: 0.5 }}>
                                                        <Box style={{ display: "flex", gap: "10px", justifyContent: 'space-between' }}>
                                                            <Typography variant="body1" style={{ minWidth: '100px', maxWidth: '100px' }}>
                                                                {item.name}
                                                            </Typography>
                                                            <Typography variant="body1" style={{ width: '50px', display: "inline-block", textAlign: "center" }}>
                                                                {item.quantity}
                                                            </Typography>
                                                            <Typography variant="body1" style={{ width: '80px', display: "inline-block", textAlign: "right" }}>
                                                                {formatPercentBR(item.percent)}%
                                                            </Typography>
                                                        </Box>
                                                        <Divider sx={{ mt: 0.5 }} />
                                                    </Box>
                                                ))}
                                        </Box>
                                    </>
                                ) : (
                                    <Typography variant="body2">Sem dados de cor.</Typography>
                                )}
                            </CardContent>
                            <Box
                                sx={{
                                    marginTop: 'auto'
                                }}
                            >
                                <CardContent sx={{ paddingBottom: "16px !important" }}>
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'row',
                                            width: '100%',
                                            justifyContent: 'space-between'
                                        }}
                                    >
                                        <Box width={"100px"}>
                                            <Typography variant="h6" fontWeight={"bold"}>
                                                Devoluções
                                            </Typography>
                                            <Typography variant="body1">R$ {totalProdsValueReturned === 0 ? " - " : formatNumber(totalProdsValueReturned)}</Typography>
                                        </Box>
                                        <Box sx={{ height: '40px', display: 'flex', alignItems: 'center' }}>
                                            <Divider orientation="vertical" variant="middle" />
                                        </Box>
                                        <Box>
                                            <Typography variant="h6" fontWeight={"bold"}>
                                                Quantidade
                                            </Typography>
                                            <Typography variant="body1">{totalProdsReturned === 0 ? " - " : totalProdsReturned}</Typography>
                                        </Box>
                                    </Box>
                                </CardContent>
                                <Divider />
                                <CardContent sx={{ paddingBottom: "16px !important" }}>
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'row',
                                            width: '100%',
                                            justifyContent: 'space-between'
                                        }}
                                    >
                                        <Box width={"100px"}>
                                            <Typography variant="h6" fontWeight={"bold"}>
                                                Vendas
                                            </Typography>
                                            <Typography variant="body1">R$ {totalProdsValueSold === 0 ? " - " : formatNumber(totalProdsValueSold)}</Typography>
                                        </Box>
                                        <Box sx={{ height: '40px', display: 'flex', alignItems: 'center' }}>
                                            <Divider orientation="vertical" variant="middle" />
                                        </Box>
                                        <Box>
                                            <Typography variant="h6" fontWeight={"bold"}>
                                                Quantidade
                                            </Typography>
                                            <Typography variant="body1">{totalProdsSold === 0 ? " - " : totalProdsSold}</Typography>
                                        </Box>
                                    </Box>
                                </CardContent>
                            </Box>
                        </Paper>
                    </Box>
                }

                <Box
                    sx={{
                        minHeight: '680px',
                        width: '100%',
                        padding: '10px',
                        backgroundColor: colors.pink[700],
                        borderRadius: '4px',
                        display: 'flex',
                        flexDirection: 'column',
                        boxShadow: 'inset 0px 4px 10px rgba(0, 0, 0, 0.6)',
                        alignSelf: 'stretch'
                    }}
                >

                    {
                        dataToEdit?.kit_number &&
                        <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                            {/* Inadimplente */}
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                                <Typography variant="h4" color={colors.grey[200]} fontWeight="bold">
                                    Inadimplente:
                                </Typography>
                                <Tooltip
                                    title="Informa se a Vendedora está inadimplente com a empresa."
                                    arrow
                                    placement="top"
                                    componentsProps={{
                                        tooltip: {
                                            sx: {
                                                fontSize: "0.8rem",
                                                backgroundColor: colors.pink[800],
                                                color: "#fff",
                                                borderRadius: '8px',
                                                boxShadow: 'inset 0px 4px 10px rgba(0, 0, 0, 0.6)'
                                            },
                                        },
                                    }}
                                >
                                    <Switch
                                        checked={failureToPay}
                                        onChange={handleChangeFailure}
                                        color="warning"
                                        inputProps={{ 'aria-label': 'controlled' }}
                                    />
                                </Tooltip>
                            </Box>
                            <Button
                                variant="contained"
                                color="info"
                                onClick={handleClick}
                                disabled={loadingBtnImg}
                                startIcon={loadingBtnImg ? <CircularProgress size={20} /> : null}
                                endIcon={!loadingBtnImg ? <PictureAsPdfIcon /> : null}
                            >
                                {loadingBtnImg ? 'Gerando PDF...' : 'Gerar PDF'}
                            </Button>

                            {/* KIT */}
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                                <Typography variant="h4" color={colors.grey[200]} fontWeight="bold">
                                    KIT {dataToEdit?.kit_number}
                                </Typography>
                                <Tooltip
                                    title="KIT Devolvido ?"
                                    arrow
                                    placement="top"
                                    componentsProps={{
                                        tooltip: {
                                            sx: {
                                                fontSize: "1.1rem",
                                                backgroundColor: colors.pink[800],
                                                color: "#fff",
                                                borderRadius: '8px',
                                                boxShadow: 'inset 0px 4px 10px rgba(0, 0, 0, 0.6)'
                                            },
                                        },
                                    }}
                                >
                                    <Switch
                                        checked={isActiveKit}
                                        onChange={handleChangeActive}
                                        color="secondary"
                                        inputProps={{ 'aria-label': 'controlled' }}
                                    />
                                </Tooltip>
                            </Box>
                        </Box>
                    }
                    <Box
                        sx={{
                            padding: '10px',
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            marginBottom: '20px',
                            alignItems: 'end'
                        }}
                    >
                        <Box
                            display={"flex"}
                            alignItems={"end"}
                            flexDirection={"row"}
                            justifyContent={formType === 'Criando' ? "space-between" : 'flex-start'}
                            gap={"20px"}
                            width={formType === 'Criando' ? "100%" : 'auto'}
                        >
                            {/* <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}> */}
                            <Box>
                                <Typography variant="h6" color={'whitesmoke'} sx={{ paddingTop: '20px', alignSelf: 'flex-start' }}>
                                    insira um ID:
                                </Typography>
                                <TextField
                                    id="outlined-basic"
                                    label="ID"
                                    variant="standard"
                                    value={value}
                                    onChange={handleChange}
                                    inputProps={{ maxLength: 6 }} // Set the max length here
                                />
                            </Box>
                            {
                                valuesToSave && valuesToSave.length > 0 &&
                                <>

                                    <LocalizationProvider
                                        dateAdapter={AdapterDayjs}
                                        adapterLocale="pt-br"
                                    >
                                        <DesktopDatePicker
                                            label="Data Acerto"
                                            inputFormat="DD/MM/YYYY"
                                            value={initialDate}
                                            onChange={handleChangeDate}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    size="small"
                                                    placeholder="Data Acerto"
                                                    sx={{
                                                        width: "135px",
                                                        backgroundColor: colors.blueOrigin[800],
                                                        "& .MuiInputBase-input": {
                                                            fontSize: "0.82rem",
                                                            padding: "8px 10px",
                                                        },
                                                        "& .MuiInputLabel-root": {
                                                            fontSize: "0.82rem",
                                                        },
                                                    }}
                                                />
                                            )}
                                        />
                                    </LocalizationProvider>
                                    <FormControl
                                        sx={{
                                            mt: 0,
                                            width: '125px',
                                            display: 'flex',
                                            flexDirection: 'column',
                                        }}
                                        size="small"
                                        required={formType === "Criando"}
                                        error={isCaseRequiredError}
                                    >
                                        <Typography
                                            variant="caption"
                                            sx={{
                                                color: isCaseRequiredError ? "#ffb4b4" : "whitesmoke",
                                                mb: 0.4,
                                                fontWeight: 700,
                                                lineHeight: 1.1,
                                            }}
                                        >
                                            {isCaseRequiredError ? "Selecione o tipo" : "Case"}
                                        </Typography>

                                        <Select
                                            id="case"
                                            size="small"
                                            name="case"
                                            value={caseType || ""}
                                            displayEmpty
                                            onChange={handleChangeCaseType}
                                            sx={{
                                                color: "white",
                                                fontSize: "0.82rem",
                                                height: "38px",
                                                backgroundColor: "rgba(0,0,0,0.08)",
                                                "& .MuiSelect-select": {
                                                    padding: "8px 10px",
                                                },
                                                "& .MuiOutlinedInput-notchedOutline": {
                                                    borderColor: isCaseRequiredError ? "#ff6b6b" : "gray",
                                                },
                                                "&:hover .MuiOutlinedInput-notchedOutline": {
                                                    borderColor: isCaseRequiredError ? "#ff6b6b" : "whitesmoke",
                                                },
                                                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                    borderColor: isCaseRequiredError ? "#ff6b6b" : "white",
                                                },
                                                "& .MuiSvgIcon-root": {
                                                    color: "whitesmoke",
                                                },
                                            }}
                                        >
                                            <MenuItem value="">
                                                <em>Selecionar</em>
                                            </MenuItem>
                                            <MenuItem value="Bandeja">Bandeja</MenuItem>
                                            <MenuItem value="Bolsa P">Bolsa P</MenuItem>
                                            <MenuItem value="Bolsa M">Bolsa M</MenuItem>
                                            <MenuItem value="Maleta P">Maleta P</MenuItem>
                                            <MenuItem value="Maleta G">Maleta G</MenuItem>
                                        </Select>
                                    </FormControl>
                                </>

                            }
                            {
                                formType === 'Criando' && (
                                    <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', alignItems: 'center', gap: '20px', alignSelf: 'baseline' }}>
                                        <Typography color={colors.greenAccent[400]} sx={{ alignSelf: 'end', fontSize: '16px' }} fontWeight={"bold"}>
                                            KIT {lastKitNumber}
                                        </Typography>
                                    </Box>
                                )
                            }
                        </Box>
                        {
                            formType === 'Editando' &&
                            <>
                                <Box>

                                    <Typography variant="h6" color={'whitesmoke'} sx={{ paddingTop: '20px', alignSelf: 'flex-start' }}>
                                        insira um ID para Devolução:
                                    </Typography>
                                    <TextField
                                        id="id_prod_devolucao"
                                        label="ID"
                                        variant="standard"
                                        value={devIdValue}
                                        onChange={handleChangeReturn}
                                        autoComplete="off"
                                        inputProps={{
                                            maxLength: 6,
                                            autoComplete: "off",
                                        }}
                                    />
                                </Box>
                            </>
                        }
                    </Box>
                    {
                        valuesToSave && valuesToSave.length > 0 &&
                        <Divider />
                    }
                    {
                        valuesToSave.length === 0 &&
                        <>
                            <Box
                                sx={{
                                    width: '100%',
                                    height: '80%',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                }}
                            >
                                <Typography variant="h2" color={colors.primary[100]} sx={{ paddingTop: '20px' }}>
                                    Comece inserindo um produto...
                                </Typography>
                            </Box>
                        </>
                    }
                    <Box
                        sx={{
                            padding: '10px 10px 0px 10px'
                        }}
                    >
                        {
                            valuesToSave && valuesToSave.length > 0 &&
                            <Paper elevation={5}
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'flex-start',
                                    width: "100%",
                                    // marginTop: '10px',
                                    marginBottom: '10px',
                                    backgroundColor: colors.pink[800],
                                    borderRadius: '4px',
                                    padding: '8px 15px',
                                    alignItems: 'center',
                                    position: 'sticky',
                                    top: 0
                                }}
                            >

                                <Box
                                    sx={{
                                        display: 'grid',
                                        gridTemplateColumns: 'repeat(8, 2fr)',
                                        gap: '20px',
                                        width: '80%',
                                        justifyContent: 'flex-start',
                                        // position: 'sticky',
                                        fontWeight: 'bold'
                                    }}
                                >
                                    <span
                                        onClick={() => setOrderByNumber(!orderByNumber)}
                                        style={{ cursor: 'pointer', color: orderByNumber ? 'yellowgreen' : 'yellow' }}
                                        title={orderByNumber ? "Sort ID Produto" : "Sort Inserido"}
                                        aria-label={orderByNumber ? "Sort A-Z" : "Sort Z-A"}
                                    >
                                        <FontAwesomeIcon icon={orderByNumber ? faSortAlphaDown : faSortAlphaUpAlt} />
                                    </span>
                                    <span>Imagem</span>
                                    <span>Tipo</span>
                                    <span>ID Produto</span>
                                    <span>Tamanho</span>
                                    <span>Cor</span>
                                    <span>Valor</span>
                                    <span>Inserido</span>
                                </Box>
                            </Paper>
                        }
                    </Box>
                    <Box
                        sx={{
                            flex: 1,
                            overflow: "hidden",
                            padding: "10px",
                            paddingTop: "0px",
                        }}
                    >
                        {valuesToSave && valuesToSave.length > 0 && (
                            <FixedSizeList
                                height={600}              // 👉 ajusta se quiser maior/menor
                                itemCount={sortedValues.length}
                                itemSize={60}             // 👉 altura média de cada linha (tune fino depois)
                                width="100%"
                                itemKey={(index) => {
                                    const r = sortedValues[index];
                                    return r?.unit_id || `${r?.pk}-${r?.object_id}-${r?.id_produto}-${r?.tamanho ?? ""}-${index}`;
                                }}
                            >
                                {({ index, style }) => {
                                    const row = sortedValues[index];
                                    return (
                                        <TableFormKit
                                            style={style}                 // 👈 importante pro react-window
                                            formType={formType}
                                            data={row}
                                            index={index}
                                            prodHandler={prodHandler}
                                            lenTable={sortedValues.length}
                                            handleRemoveDevolvido={handleRemoveDevolvido}
                                            handleChangeReturn={handleChangeReturn}
                                            handleChangeSoldProd={handleChangeSoldProd}
                                        />
                                    );
                                }}
                            </FixedSizeList>
                        )}
                    </Box>


                </Box>
            </Box>
        </>
    );
}

export default FormKitPage;